import Logger from '../lib/Logger';
import { isGdprCountry } from './GdprExcludedCountries';
import { doIpLookup } from './ipLookup';
const eventDetails = {
  consent: null,
  country: null,
  isGdprCountry: false
};
export const GdprEventSetup = (lookup = doIpLookup) => {
  window._hsp = window._hsp || [];
  const logger = Logger.getLogger('setupGdprEvents');
  lookup().then(country => {
    eventDetails.country = country;
    eventDetails.isGdprCountry = isGdprCountry(country);
    document.dispatchEvent(new CustomEvent('gdpr', {
      detail: eventDetails
    }));
  }).catch(errorMessage => {
    logger.warn(errorMessage);
  });

  window._hsp.push(['addPrivacyConsentListener', consent => {
    eventDetails.consent = consent;
    document.dispatchEvent(new CustomEvent('gdpr', {
      detail: eventDetails
    }));
  }]);
};